import { StateCreator } from 'zustand';
import getRecentSearches from '../../api/recent-search-api';
import { IAppState, IRecentSearchesSlice } from './stateTypes';

const createRecentSearchesSlice: StateCreator<IAppState, [], [], IRecentSearchesSlice> = (set, get) => ({
    isLoadingRecentSearches: false,
    recentSearches: [],
    hasLoadedRecentSearches: false,
    loadRecentSearches: async () => {
        set({ isLoadingRecentSearches: true });

        // VisitorId might already be set, but since it's just a cookie lookup, no harm
        get().setVisitorId();

        // Since this involves a call to validate the auth cookie,
        // if it's already set we don't want to check the cookie again
        if (!get().ciamId) {
            await get().setCiam();
        }

        const visitorId = get().visitorId;
        const ciamId = get().ciamId;

        try {
            const recentSearches = await getRecentSearches({ visitorId, userId: ciamId });
            set({ recentSearches });
        } catch (error) {
            console.error('Error loading recent searches:', error);
        } finally {
            set({ isLoadingRecentSearches: false, hasLoadedRecentSearches: true });
        }
    },
});

export default createRecentSearchesSlice;
